/*
 * Peel Collection — interactivity.
 * Compare selection bar, the device fit filter, scroll reveals,
 * and AJAX filter/sort/pagination for the product grid (fetches the
 * grid section via Shopify's section rendering endpoint and swaps it
 * in place, instead of a full page navigation).
 * Loaded on the default collection template and on
 * collection.all-cases. Relies on assets/peel-common.js
 * (peelInitScrollReveal, peelInitDeviceSelects) and
 * assets/peel-device-map.js.
 */
(function () {
  var MAX_COMPARE = 4;
  var compareSelection = [];

  document.addEventListener('DOMContentLoaded', function () {
    peelInitScrollReveal([
      '.peel-plp-section',
      '.peel-stats-band',
      '.peel-stats-alt',
      '.peel-lifestyle-section .peel-section-head',
      '.peel-lifestyle-item',
      '.peel-style-split-section',
      '.peel-testimonial-section',
      '.peel-ugc-section',
      '.peel-lookbook-section',
      '.peel-press-band',
      '.faqs-section',
      '.peel-newsletter-band'
    ]);
    initDevicePicker();
    /* If the last filter change on this collection had to give up on the
       AJAX swap and load the page, put the panel back the way it was. */
    restoreStashedPanel();
  });

  /* ---- Device fit filter ----------------------------------------------
     The hero picker drives Shopify's own phone-model filter. The products
     declare their compatibility in metafields (custom.iphone_model and
     friends), Search & Discovery exposes that as a storefront filter, and
     the grid section renders that filter's values along with the URLs
     Shopify generates for them. Picking a phone just follows one of those
     URLs through the same AJAX swap the sidebar filters use — so the
     result is server-filtered: counted, paginated, and correct on a
     collection of any size.

     A phone the picker offers but this collection has no value for can't
     be filtered on; that says the collection carries nothing for it. */
  var picker = null;
  /* The phone the grid is filtered to, and the one the picker is showing.
     They part company between choosing and pressing the arrow. */
  var fitDevice = null;
  var pendingDevice = null;
  var fitModelSelect = null;

  function initDevicePicker() {
    var brandSelect = document.querySelector('[data-plp-brand-select]');
    var modelSelect = document.querySelector('[data-plp-model-select]');
    if (!brandSelect || !modelSelect) return;
    var wrap = brandSelect.closest('[data-peel-device-picker]');
    fitModelSelect = modelSelect;

    /* Whatever the page is already filtered to wins, then the phone handed
       over from the homepage. A phone merely remembered from an earlier
       visit does not filter a collection the shopper just opened — it would
       be a surprise, and a request nobody asked for.

       "Already filtered to" is now a set: the panel can arrive with three
       models on. The picker can show one name, so it shows a name only
       when there is one to show — but a page filtered to any number of
       models is still a page that asked for its own phones, and the
       homepage's handoff does not get to narrow it. */
    var actives = activeDeviceValues();
    var active = actives.length === 1 ? actives[0] : null;
    var urlKey = new URLSearchParams(window.location.search).get('device');
    var startKey = (actives.length ? (active ? catalogKeyFor(deviceKeyForValue(active)) : '') : urlKey) || '';

    picker = peelInitDeviceSelects(brandSelect, modelSelect, {
      includeAny: true,
      anyLabel: (wrap && wrap.getAttribute('data-plp-any-label')) || 'All models',
      selectFirst: false,
      initialKey: startKey,
      initialBrand: collectionBrand(),
      onChange: function (device, meta) {
        pendingDevice = device;

        /* On load the grid is already whatever the URL asked for; a phone
           handed over from the homepage is a choice already made, so it
           applies itself. */
        if (meta.initial) {
          fitDevice = device;
          updateFitChip();
          if (device && !actives.length) applyFit(device);
          else showFitNote(false);
          syncApplyButton();
          return;
        }

        /* A change here only arms the arrow — brand and model can both be
           set before the grid moves. */
        showFitNote(false);
        syncApplyButton();
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-plp-fit-apply]')) {
        event.preventDefault();
        applyFit(pendingDevice);
        return;
      }
      if (!event.target.closest('[data-plp-fit-clear]')) return;
      event.preventDefault();
      /* Clearing is its own instruction — it doesn't wait for the arrow. */
      if (picker) picker.select(null);
      applyFit(null);
    });
  }

  /* The one brand this collection's own products are for, where they are
     all one brand's — a Galaxy S26 Ultra collection, the Samsung cases —
     so the picker opens on Samsung there rather than on Apple, the first
     brand in the list. Worked out in snippets/peel-device-catalog.liquid
     off the read the catalogue already makes; a collection of every
     brand, or of none, carries nothing and opens as it always has. Only
     the brand: the model stays on "All models", so the grid is not
     filtered before the shopper asks. */
  function collectionBrand() {
    var node = document.querySelector('[data-peel-device-models]');
    return (node && node.getAttribute('data-collection-brand')) || '';
  }

  /* The arrow is live only while the picker is showing something other
     than what the grid already has. */
  function syncApplyButton() {
    var button = document.querySelector('[data-plp-fit-apply]');
    if (!button) return;
    var pendingKey = pendingDevice ? pendingDevice.key : '';
    var appliedKey = fitDevice ? fitDevice.key : '';
    button.disabled = pendingKey === appliedKey;
  }

  /* The phone-model filter's values, as the grid section rendered them. */
  function deviceFilterValues() {
    var node = document.querySelector('[data-plp-device-filters]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function activeFilterValue() {
    var values = deviceFilterValues();
    for (var i = 0; i < values.length; i++) {
      if (values[i].active) return values[i];
    }
    return null;
  }

  /* The phone catalogue lives in assets/peel-device-map.js, a separate
     file. Everything below that reads it is reached only once a
     phone-model value is on — so a page that never got that file worked
     perfectly until the shopper ticked a model, and then threw from
     inside the grid swap. Asked for rather than assumed, so the loss of
     one script costs the fit chip and nothing else. */
  function deviceMap() {
    return window.peelDeviceMap || null;
  }

  function deviceKeyForValue(value) {
    var map = deviceMap();
    if (!map) return '';
    return map.slug(value.value || value.label || '');
  }

  /* The picker's key for a phone the filter spells its own way. */
  function catalogKeyFor(rawKey) {
    var map = deviceMap();
    if (!map) return null;
    var wanted = map.normalize(rawKey);
    var match = null;
    map.catalog().forEach(function (brand) {
      brand.models.forEach(function (model) {
        if (!match && map.normalize(model.key) === wanted) match = model.key;
      });
    });
    return match;
  }

  /* The filter spells a phone however Search & Discovery was set up
     ("Samsung S26 Ultra" or "Samsung Galaxy S26 Ultra"), so match on the
     brand-stripped key rather than the exact string. */
  function filterValueFor(device) {
    var map = deviceMap();
    if (!device || !map) return null;
    var wanted = map.normalize(device.key);
    var values = deviceFilterValues();
    for (var i = 0; i < values.length; i++) {
      if (map.normalize(deviceKeyForValue(values[i])) === wanted) return values[i];
    }
    return null;
  }

  /* Every phone-model value the grid is currently filtered by. More than
     one is what this guards against: a shopper has one phone, so picking
     a second model means "that one instead", never "both". */
  function activeDeviceValues() {
    return deviceFilterValues().filter(function (value) {
      return value.active;
    });
  }

  function dropParamValue(url, name, value) {
    if (!name) return;
    var kept = url.searchParams.getAll(name).filter(function (v) {
      return v !== value;
    });
    url.searchParams.delete(name);
    kept.forEach(function (v) {
      url.searchParams.append(name, v);
    });
  }

  /* The grid's URL with exactly the one phone on — or none, for null.
     Built from the address bar rather than from Shopify's url_to_add,
     which appends to whatever is already filtered: from a collection
     already showing one model, that URL asks for both. Every other
     filter the shopper set is left alone, and `page` goes because the
     first page of a different phone's cases is the one to land on. */
  function deviceFilterUrl(value) {
    var actives = activeDeviceValues();
    /* Depict regenerates its copy of the grid section on its own
       schedule, so a page can still be rendering the filter JSON as it
       was before `param` joined it. Nothing to rewrite a query with
       then: say so, and let the caller fall back to Shopify's own URL. */
    var named = actives.every(function (other) {
      return !!other.param;
    });
    if (!named || (value && !value.param)) return null;

    var url = new URL(window.location.href);
    actives.forEach(function (other) {
      dropParamValue(url, other.param, other.value);
    });
    if (value) url.searchParams.append(value.param, value.value);
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  function applyFit(device) {
    var active = activeFilterValue();
    fitDevice = device;
    pendingDevice = device;
    updateFitChip();
    syncApplyButton();

    if (!device) {
      showFitNote(false);
      if (active) peelUpdateGrid(withoutDeviceParam(deviceFilterUrl(null) || active.remove));
      return;
    }

    var value = filterValueFor(device);
    if (!value) {
      /* Nothing here is made for it — leave the collection as it is and
         say so, rather than showing an empty grid. */
      showFitNote(true);
      return;
    }
    showFitNote(false);
    /* Already showing this phone and nothing else: nothing to ask for. */
    if (value.active && activeDeviceValues().length === 1) return;
    peelUpdateGrid(withoutDeviceParam(deviceFilterUrl(value) || value.add));
  }

  /* Shopify's filter URLs are built from the current one, so they carry
     the homepage's ?device= along. It has done its job by now. */
  function withoutDeviceParam(href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.delete('device');
    return url.pathname + url.search;
  }

  function updateFitChip() {
    var chip = document.querySelector('[data-plp-fit-chip]');
    if (!chip) return;
    var name = chip.querySelector('[data-plp-fit-model]');
    if (name) name.textContent = fitDevice ? fitDevice.model : '';
    chip.hidden = !fitDevice;
    updateDeviceChips();
    updateFilterBar();
    updateDeviceNote();
  }

  /* Every active filter is rendered as a chip, the phone model included,
     so that a model the device catalogue does not recognise still has
     something on the row standing for it. When the fit chip is up it is
     already saying that phone's name, and the two together said it twice
     — so for as long as the fit chip speaks for a value, that value's own
     chip steps aside. Matched on the value rather than the label, because
     the fit chip shows the catalogue's spelling of the phone and the chip
     shows Search & Discovery's.

     The removal link is on the chip being hidden, but nothing is lost:
     the fit chip carries its own clear. */
  function updateDeviceChips() {
    var value = fitDevice ? filterValueFor(fitDevice) : null;
    var covered = value && value.active ? String(value.value) : null;
    var chips = document.querySelectorAll('[data-plp-device-chip]');
    Array.prototype.forEach.call(chips, function (chip) {
      chip.hidden = covered !== null && chip.getAttribute('data-plp-device-chip') === covered;
    });
  }

  /* The row under the toolbar holds its spacing off is-active rather
     than off being in the markup, so that with nothing on it collapses
     instead of leaving a band of air over the grid. Liquid sets the
     class for the filters the page came back with; the fit chip can
     come and go between two of those, without a swap, so the row is
     told again here. */
  function updateFilterBar() {
    var bar = document.querySelector('[data-plp-filter-bar]');
    if (!bar) return;
    var shown = bar.querySelector('.peel-plp-chip:not([hidden]), .peel-plp-fit:not([hidden])');
    if (shown) bar.classList.add('is-active');
    else bar.classList.remove('is-active');
  }

  /* The sidebar can set the same filter the picker does, so after a swap
     take the page's word for which phone is showing. Sets the control
     directly rather than through the picker, which would fire a second
     request for a filter that is already applied.

     The panel can now put several models on at once, and the picker and
     its chip have room for exactly one name. Rather than pick one of
     three and misreport the grid, both stand down and leave the row to
     the per-model chips, which can say all three. */
  function syncFitFromFilters() {
    var actives = activeDeviceValues();
    var active = actives.length === 1 ? actives[0] : null;
    var key = active ? catalogKeyFor(deviceKeyForValue(active)) : null;
    var map = deviceMap();
    var model = key && map ? map.findModel(key) : null;
    fitDevice = model ? { brand: model.brand, model: model.model, key: model.key } : null;
    pendingDevice = fitDevice;

    if (fitModelSelect) {
      var wanted = fitDevice ? fitDevice.key : '';
      var options = fitModelSelect.options;
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === wanted) {
          fitModelSelect.value = wanted;
          break;
        }
      }
    }
    updateFitChip();
    syncApplyButton();
  }

  function showFitNote(show) {
    var note = document.querySelector('[data-plp-fit-note]');
    var section = document.querySelector('[data-plp-section-id]');
    if (!note || !section) return;
    if (show && fitDevice) {
      var template = section.getAttribute('data-plp-fit-empty') || 'Nothing here fits the [model].';
      note.textContent = template.replace('[model]', fitDevice.model);
    }
    note.hidden = !show;
  }

  /* The count reads back the phone once the grid is showing it. */
  function updateDeviceNote() {
    var note = document.querySelector('[data-plp-device-note]');
    if (!note) return;
    note.textContent = fitDevice && filterValueFor(fitDevice) ? ' fit ' + fitDevice.model : '';
  }

  /* ---- Compare selection: toggled inline via onchange on each card ---- */
  window.peelToggleCompare = function (checkbox) {
    var name = checkbox.getAttribute('data-cmp');
    if (!name) return;

    if (checkbox.checked) {
      if (compareSelection.length >= MAX_COMPARE) {
        checkbox.checked = false;
        return;
      }
      compareSelection.push(name);
    } else {
      compareSelection = compareSelection.filter(function (n) {
        return n !== name;
      });
    }

    updateCompareBar();
  };

  function updateCompareBar() {
    var bar = document.querySelector('[data-plp-compare-bar]');
    var list = document.querySelector('[data-plp-compare-list]');
    var cta = document.querySelector('[data-plp-compare-cta]');
    if (list) list.textContent = compareSelection.length ? compareSelection.join(' vs ') : 'nothing yet';
    if (bar) bar.classList.toggle('is-visible', compareSelection.length > 0);
    if (cta) cta.disabled = compareSelection.length < 2;
  }

  /* ---- AJAX filter / sort / pagination for the grid section ----
     Fetches the current URL's collection grid section on its own via
     Shopify's `?section_id=` section rendering endpoint and swaps the
     rendered wrapper in place, so filtering never leaves the page. */
  function getGridWrapper() {
    var root = document.querySelector('[data-plp-section-id]');
    if (!root) return null;
    var sectionId = root.getAttribute('data-plp-section-id');
    return document.getElementById('shopify-section-' + sectionId);
  }

  /* The query keys this section owns. Rebuilt from the form and from
     Shopify's own filter URLs on every update, so they are the ones that
     must NOT be carried over from the current URL — a box that was
     unticked would come straight back. `device` belongs here too: the
     hero picker hands it over once and applyFit() strips it deliberately. */
  var OWN_PARAMS = ['sort_by', 'page', 'section_id', 'device'];

  /* Shopify builds its filter and pagination URLs from the current one,
     so they arrive carrying whatever else the query held. The filter form
     does not — it builds from the collection's URL and the ticked boxes
     alone, dropping everything else. In the theme editor that includes
     preview_theme_id, and a request without it is answered by the
     published theme instead: the section we asked for is not in that
     response, the swap throws, and the shopper sees nothing happen.

     So carry over any key the target URL has not set for itself. */
  function withCurrentParams(url) {
    var target = new URL(url, window.location.href);
    /* Shopify builds url_to_remove from the request it is answering, and
       during a section render that request carries section_id. Pushed to
       the address bar it would give the shopper a link that answers with
       the bare section instead of a page. */
    target.searchParams.delete('section_id');
    new URL(window.location.href).searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) return;
      if (OWN_PARAMS.indexOf(key) > -1) return;
      if (target.searchParams.has(key)) return;
      target.searchParams.append(key, value);
    });
    return target.pathname + target.search;
  }

  /* ---- Collapsible filter groups ----
     Each group in the panel is a <details>, which needs no script to
     open — but the AJAX swap below replaces the whole section, so
     without somewhere to keep it every group would spring back to the
     state the section renders the moment a box was ticked: the shopper
     opens Colour, picks one, and the group they were working in folds
     shut under them. Keyed by filter param, so it survives a swap that
     reorders the groups or drops one whose values all went to zero. */
  var openFilterGroups = null;

  function eachFilterGroup(fn) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-plp-filter-group]'), fn);
  }

  function rememberFilterGroups() {
    var seen = {};
    var found = false;
    eachFilterGroup(function (group) {
      seen[group.getAttribute('data-plp-filter-group')] = group.open;
      found = true;
    });
    /* Only when there was a panel to read. A swap that arrives before
       one is on the page must not wipe what an earlier one recorded. */
    if (found) openFilterGroups = seen;
  }

  function applyFilterGroups() {
    if (!openFilterGroups) return;
    eachFilterGroup(function (group) {
      var key = group.getAttribute('data-plp-filter-group');
      /* A group that has just come on gets to keep the open state the
         section rendered for it — that is the one case where the server
         knows better than the record. */
      if (Object.prototype.hasOwnProperty.call(openFilterGroups, key)) {
        group.open = openFilterGroups[key];
      }
    });
  }

  /* ---- Carrying the panel over a page load ----
     The sheet's open state and the record above live in this closure and
     nowhere else, which is fine for the AJAX swap — it never leaves the
     page. The fallback below does: a request that fails for any reason
     is answered with a full page load, and a full page load starts this
     file again with the sheet shut and every group folded. The filter
     itself applies, so from the shopper's side nothing happened except
     that the panel they were working in vanished — and, because which
     requests fail is a property of the request, it vanishes on some
     filter values and not others.

     So a fallback hands the panel forward. Written once, read once, and
     matched to the collection that wrote it, so it restores the panel
     the shopper was just in and never reopens one on a later visit. */
  var PANEL_HANDOFF_KEY = 'peel:plp-panel';

  function stashPanel() {
    rememberFilterGroups();
    try {
      window.sessionStorage.setItem(PANEL_HANDOFF_KEY, JSON.stringify({
        path: window.location.pathname,
        open: filtersOpen,
        groups: openFilterGroups || {}
      }));
    } catch (error) {
      /* Private browsing, or a full store — the panel closes, as it did
         before. Nothing here is worth failing the navigation over. */
    }
  }

  function takeStashedPanel() {
    var raw = null;
    try {
      raw = window.sessionStorage.getItem(PANEL_HANDOFF_KEY);
      /* Read once: a reload, or the back button landing here later, is
         not the filter change this was handed over for. */
      window.sessionStorage.removeItem(PANEL_HANDOFF_KEY);
    } catch (error) {
      return null;
    }
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.path !== window.location.pathname) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function restoreStashedPanel() {
    var stashed = takeStashedPanel();
    if (!stashed) return;
    if (stashed.groups) {
      openFilterGroups = stashed.groups;
      applyFilterGroups();
    }
    if (stashed.open) setFilterSheet(true);
  }

  /* Every path out of peelUpdateGrid that gives up on the swap and loads
     the page instead. */
  function fallbackToPageLoad(url) {
    stashPanel();
    window.location.href = url;
  }

  function peelUpdateGrid(rawUrl, pushHistory) {
    var url = withCurrentParams(rawUrl);
    var wrapperEl = getGridWrapper();
    if (!wrapperEl) {
      fallbackToPageLoad(url);
      return;
    }
    var sectionId = wrapperEl.id.replace(/^shopify-section-/, '');
    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    /* Which groups are open right now, so the swap can put them back. */
    rememberFilterGroups();

    /* Inert, but not dimmed, while the grid is on its way: the class
       carries pointer-events:none and nothing else, so the shopper keeps
       looking at the products they already have until the new ones swap
       in. The only thing that took the class off again was the swap
       replacing the node it sat on — so any update that did not land
       left the whole section unclickable: filter rows, the toggle, the
       chips, all of it, with no way back but a reload. That is the state
       the theme editor lands in every time, because the fallback below is
       a navigation and the editor blocks those. Release it on every path
       that leaves this node on the page. */
    var innerEl = wrapperEl.querySelector('.peel-plp-section');
    if (innerEl) innerEl.classList.add('is-loading');
    function releaseGrid() {
      if (innerEl) innerEl.classList.remove('is-loading');
    }

    /* Whether the new markup is already on the page, which decides what a
       failure below means: a grid that never arrived, or one that arrived
       and then tripped over something on its way to settling. */
    var swapped = false;

    fetch(fetchUrl.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('Grid fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newWrapper = doc.getElementById(wrapperEl.id);
        if (!newWrapper) throw new Error('Grid section not found in response');

        wrapperEl.replaceWith(newWrapper);
        swapped = true;

        /* The swap replaces the sheet along with everything else, so the
           open state has to be put back — a filter change should not
           dismiss the sheet the shopper is still using, nor fold up the
           group they were picking from.

           First of everything that follows the swap, deliberately: the
           rest of this block is the toolbar catching up, and none of it
           is worth the panel closing under a shopper if it throws. */
        applyFilterSheet();
        applyFilterGroups();

        compareSelection = [];
        updateCompareBar();
        /* The swap brings a fresh toolbar, and may have changed the phone
           filter from the sidebar rather than the picker. */
        syncFitFromFilters();
        showFitNote(false);

        if (pushHistory !== false) {
          history.pushState({ peelPlpGrid: true }, '', url);
        }
      })
      .catch(function (error) {
        /* In the theme editor a hard navigation is blocked, so without a
           word here the failure is silent and unexplainable — and the
           section has to be handed back either way, since the navigation
           that would have replaced it may never happen. */
        releaseGrid();
        /* Past the swap the shopper already has the grid they asked for.
           Loading the page over the top of it would fix nothing and
           dismiss the panel they are still picking from, so say what
           went wrong and leave the page alone. */
        if (swapped) {
          console.warn('Peel collection grid: swapped, but settling it failed.', error);
          return;
        }
        console.warn('Peel collection grid: falling back to a page load.', error);
        fallbackToPageLoad(url);
      });
  }

  /* ---- Filter sheet ----
     On a phone the sidebar is a bottom sheet opened from the toolbar.
     Delegated from the document, because the AJAX grid swap replaces the
     section's markup and would drop any listener bound to the button. */
  var filtersOpen = false;

  function applyFilterSheet() {
    var section = document.querySelector('.peel-plp-section');
    if (!section) return;
    section.classList.toggle('is-filters-open', filtersOpen);
    document.body.classList.toggle('peel-plp-sheet-lock', filtersOpen);
    Array.prototype.forEach.call(
      section.querySelectorAll('[data-plp-filter-toggle][aria-controls]'),
      function (btn) { btn.setAttribute('aria-expanded', filtersOpen ? 'true' : 'false'); }
    );
  }

  function setFilterSheet(open) {
    filtersOpen = open;
    applyFilterSheet();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-plp-filter-toggle]')) return;
    e.preventDefault();
    setFilterSheet(!filtersOpen);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && filtersOpen) setFilterSheet(false);
  });

  /* Every group in the panel is a plain multi-select, phone models
     included, so a shopper can hold two models on screen at once and the
     form carries both. Capture phase, because the row's own onchange
     submits the form the moment it runs — the boxes have to be settled
     before it. Delegated from the document for the same reason the sheet
     toggle is: the AJAX swap replaces every one of these inputs. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.type !== 'checkbox') return;
    var row = input.closest('.peel-plp-filter-row');
    if (!row) return;
    /* The dot is drawn from the class the section rendered, so move it
       here too: the swap is a request away, and a box that ticks without
       its row lighting up reads as a click that did not land. */
    if (input.checked) row.classList.add('is-active');
    else row.classList.remove('is-active');
  }, true);

  /* The panel's URL: the collection's own, plus what is ticked and typed.
     Blanks are dropped rather than sent — an untouched price box would
     otherwise put an empty `filter.v.price.gte=` on every URL the panel
     builds, and from there into the address bar and the shopper's
     history for a bound nobody set. */
  function filterFormUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() === '') return;
      params.append(key, value);
    });
    var query = params.toString();
    return form.action + (query ? '?' + query : '');
  }

  /* What every control in the filter panel calls, from the onchange the
     section renders on it. Deliberately not form.requestSubmit(): that
     runs the form's validation first and, on a form that fails it,
     submits nothing and says nothing — a whole panel of checkboxes
     ticking with the grid never moving. The form carries novalidate for
     the same reason; this is the half of it that survives a browser
     without requestSubmit() at all. */
  window.peelSubmitFilters = function (form) {
    var target = form || document.getElementById('peel-plp-filter-form');
    if (!target) return;
    peelUpdateGrid(filterFormUrl(target));
  };

  /* Still needed for the price group's Apply button, which is a real
     submit button. */
  document.addEventListener('submit', function (e) {
    if (e.target.id !== 'peel-plp-filter-form') return;
    e.preventDefault();
    peelUpdateGrid(filterFormUrl(e.target));
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-plp-ajax-link]');
    if (!link) return;
    e.preventDefault();
    peelUpdateGrid(link.href);
  });

  window.addEventListener('popstate', function () {
    if (getGridWrapper()) {
      peelUpdateGrid(window.location.href, false);
    }
  });
})();
